<template>
  <div id="app">
    <!-- 头部 -->
    <Header />
    <main>
      <router-view />
    </main>
    <!-- 尾部 -->
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  // 注册组件，可以在模板中使用Header和Footer标签
  components: {
    Header: Header,
    Footer: Footer
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* display: flex;
  flex-direction: column; */
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

html,
body {
  height: 100%;
  margin: 0;
}

main {
  min-height: calc(100vh - 180px); /* 设置最小高度为视窗的高度 */
  display: flex;
  /* flex: 1; */
  flex-direction: column;
  justify-content: flex-start; /* 内容靠顶部对齐 */
  padding-top: 60px;
  /* overflow-y: auto; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue